export const grabElement = async (cy: any) => {
  return await cy.on('grab', () => {
    cy.container().style.cursor = 'grabbing';
  });
};